"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DesignAssetLayerRuleSet = exports.isDesignAssetLayerData = exports.designAssetLayerUserDataRuleSet = void 0;
exports.isDesignAssetLayer = isDesignAssetLayer;
const typeguard_1 = require("../../types/typeguard");
const Layer_1 = require("./Layer");
exports.designAssetLayerUserDataRuleSet = {
  fill: typeguard_1.isNonEmptyString
};
function isDesignAssetLayer(l) {
  return l && l.type === 'design_asset' && l.image && typeof l.image === 'string' && (0, Layer_1.isLayer)(l);
}
const isDesignAssetLayerData = value => (0, typeguard_1.isType)(value, exports.designAssetLayerUserDataRuleSet);
exports.isDesignAssetLayerData = isDesignAssetLayerData;
exports.DesignAssetLayerRuleSet = {
  type: value => value === 'design_asset',
  image: typeguard_1.isNonEmptyString,
  userData: (0, typeguard_1.optional)(exports.isDesignAssetLayerData),
  linkedLayer: (0, typeguard_1.optional)(value => (0, typeguard_1.isType)(value, {
    id: typeguard_1.isNonEmptyString
  }))
};